export default __webpack_public_path__ + "static/image10-c41284b9bdba15c7fde98648d9543de3.png";